/* eslint-disable prettier/prettier */
import React from "react";

const Lock = ({ onClickHandle }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClickHandle}
  >
    <path
      d="M17.818 10.8185H16.6361V8.45487C16.6361 6.15034 14.8043 4.31853 12.4998 4.31853C10.1953 4.31853 8.36345 6.15034 8.36345 8.45487V10.8185H7.18164V8.45487C7.18164 5.50034 9.54527 3.13672 12.4998 3.13672C15.4543 3.13672 17.818 5.50034 17.818 8.45487V10.8185Z"
      fill="#666666"
    />
    <path
      d="M17.2272 20.8629H7.77272C6.76818 20.8629 6 20.0947 6 19.0902V11.9993C6 10.9947 6.76818 10.2266 7.77272 10.2266H17.2272C18.2318 10.2266 18.9999 10.9947 18.9999 11.9993V19.0902C18.9999 20.0947 18.2318 20.8629 17.2272 20.8629ZM7.77272 11.4084C7.41817 11.4084 7.18181 11.6447 7.18181 11.9993V19.0902C7.18181 19.4447 7.41817 19.6811 7.77272 19.6811H17.2272C17.5818 19.6811 17.8181 19.4447 17.8181 19.0902V11.9993C17.8181 11.6447 17.5818 11.4084 17.2272 11.4084H7.77272Z"
      fill="#666666"
    />
    <path
      d="M12.5002 14.9554C13.1529 14.9554 13.682 14.4263 13.682 13.7736C13.682 13.1209 13.1529 12.5918 12.5002 12.5918C11.8475 12.5918 11.3184 13.1209 11.3184 13.7736C11.3184 14.4263 11.8475 14.9554 12.5002 14.9554Z"
      fill="#666666"
    />
    <path d="M12.7951 13.7734H12.2042L11.6133 17.3189H13.386L12.7951 13.7734Z" fill="#666666" />
  </svg>
);

export default Lock;
